import React from "react";
import s from './Settings.module.css';


export const Settings =() => {
    return (
        <div>
            Settings
        </div>
    )
}